<script setup lang="ts">
/**
 * The scope of consolidation.
 *
 * Fixed columns rather than a free table, because these five are what a scope
 * note is required to show. A scope missing its method column is one that gets
 * sent back, and a free table makes that easy to produce by accident.
 *
 * Set like the rest of the statements: one rule under the header, percentages
 * right-aligned in tabular figures so the columns read down.
 */
import { useI18n } from 'vue-i18n'

import type { ScopeSection } from '@/domain/section'

const { t } = useI18n()

defineProps<{ section: ScopeSection }>()
</script>

<template>
  <figure class="scope">
    <table>
      <thead>
        <tr>
          <th scope="col">{{ t('sectionFields.scope.entity') }}</th>
          <th scope="col">{{ t('sectionFields.scope.country') }}</th>
          <th scope="col">{{ t('sectionFields.scope.method') }}</th>
          <th scope="col" class="is-numeric">{{ t('sectionFields.scope.control') }}</th>
          <th scope="col" class="is-numeric">{{ t('sectionFields.scope.interest') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in section.entries" :key="entry.id">
          <td>{{ entry.entity }}</td>
          <td>{{ entry.country }}</td>
          <td>{{ entry.method }}</td>
          <td class="is-numeric">{{ entry.controlPct }}</td>
          <td class="is-numeric">{{ entry.interestPct }}</td>
        </tr>
      </tbody>
    </table>
    <figcaption v-if="section.caption" class="page-caption">{{ section.caption }}</figcaption>
  </figure>
</template>

<style scoped>
.scope {
  margin: 0;
}
</style>
